module.exports = __webpack_public_path__ + "img/cyry.7fd5396c.png";